import React from 'react';
import type { ReactElement } from 'react';
import './../../pg/Global.css';
import './../Palette.css';
import './ChooseLang.css';
import TextParagraph from '../textParagraph/TextParagraph';
import PageNav from '../pageNav/PageNav';
import GridText from '../gridText/GridText';
import Spacer from '../textParagraph/Spacer';
import { useSearchParams } from 'react-router-dom';

export type PageContent = {
    header: string,
    type: string,
    content: string,
    custom: ReactElement | null,
};

type LangMapProps = {
    LangMap: Map<string, PageContent[]> | null,
};

type LangButtonProps = {
    Langs: string[],
};

export const LangSwitchButton: React.FC<LangButtonProps> = ({ Langs }) => {
    return (
        <div className='LangSwitchButtonWrap'>
            <ul className='LangSwitchButtonUl'>
                {
                    Langs.map((param) => {
                        return (
                            <form key={param} method="GET">
                                <li className='LangSwitchButton' id={'LangBtn-' + param}>
                                    <input
                                        className='LangSwitchButtonImg'
                                        type="image"
                                        src={`/flag-${param}.png`}
                                        title={'flag-' + param}
                                        alt={param}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            window.location.href = `#${window.location.pathname}?lang=${param}`;
                                        }}
                                    />
                                </li>
                            </form>
                        );
                    })
                }
            </ul >
        </div >
    );
};

export const LangSwitch: React.FC<LangMapProps> = ({ LangMap }) => {
    const [searchParams] = useSearchParams();
    const lang = searchParams.get("lang") ?? "en";

    if (LangMap === null) {
        return (<div>Error</div>);
    }
    var m = LangMap.get(lang);
    if (m == null) {
        return (<div>Error</div>);
    }

    let i = 0;
    let k = 1;
    return (
        <div>
            {
                m.map((param) => {
                    k++;
                    switch (param.type) {
                        case 'custom':
                            return (
                                <div key={param.header + k++}>
                                    {param.custom}
                                </div>);
                        // @ts-ignore
                        case 'switch':
                        // @ts-ignore
                        case 'full-title':
                        // @ts-ignore
                        case 'full':
                            i++;
                        case 'sub':
                            return (
                                <div key={param.header + k}>
                                    <TextParagraph key={param.header}
                                        Type={param.type}
                                        Key={i}
                                        ParagraphHeader={param.header}
                                        ParagraphContent={param.content} />
                                </div>)

                        case 'grid':
                            return <GridText key={k} TextList={param.content.split(',')} Flag={param.header} />
                        case 'pageNav':
                            return <PageNav key={k} FrontText={param.header} Navs={param.content.replaceAll(' ', '').split(',')} />
                        case 'spacer':
                            return <Spacer key={k} Key={i} Type={param.header} />
                    }
                })
            }
        </div>
    );
};

export default LangSwitch;
